import { Card, CardBody, Col } from "reactstrap";
import { OutlineAlertTitle } from "../../../../Constants/Constants";
import { OutlineAlertSubTitle } from "../../../../Data/UiKits/Alert";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import DarkOutline from "./DarkOutline";
import LightOutline from "./LightOutline";

const OutlineAlert = () => {
  return (
    <Col sm="12" xl="6">
      <Card>
        <CommonCardHeader title={OutlineAlertTitle} span={OutlineAlertSubTitle} />
        <CardBody>
          <LightOutline />
          <DarkOutline />
        </CardBody>
      </Card>
    </Col>
  );
};
export default OutlineAlert;
